import { Box, Checkbox, MenuItem, Typography } from '@mui/material';

import { SearchContext } from 'context/SearchContext';
import { useContext } from 'react';
interface Props {
  selectedFilterOption: string;
  filter: { value: boolean; label?: string; key: string };
}
export const BooleanFilterItem: React.FC<Props> = ({
  selectedFilterOption,
  filter
}) => {
  const { request: searchRequest, handleToggleFilter } =
    useContext(SearchContext);

  return (
    <Box>
      <MenuItem
        onClick={() =>
          handleToggleFilter(filter.value.toString(), selectedFilterOption)
        }
        sx={{
          px: 2,
          py: 1
        }}
        dense
      >
        <Checkbox
          sx={{ py: 0, px: 0.5 }}
          size="small"
          disableRipple
          checked={searchRequest?.filters?.some(el => el.field === filter.key)}
        />
        <Typography variant="caption" noWrap sx={{ color: '#000000de' }}>
          {filter.label ?? filter.value}
        </Typography>
      </MenuItem>
    </Box>
  );
};
